import { schema } from 'normalizr';

export const alertSchema = new schema.Entity('alerts');
export const alertListSchema = [alertSchema];



// WEBPACK FOOTER //
// ./src/schemas/alert.js